import Logger from "neon-frontend-utils/src/logger";
import Components from "../../../constants/Components";
import * as actionType from "./../constants/ActionTypes";

const initialState = {
    featureToggles: localStorage.getItem("featureToggles") ? JSON.parse(localStorage.getItem("featureToggles")) : [],
};

/**
 * Returns the new state
 * @param {Object} state - state
 * @param {Object} action - action
 * @returns {Object} new state
 */
export default function featureToggleReducer(state = initialState, action) {
    const newState = Object.assign({}, state);

    switch (action.type) {
        case actionType.TOGGLE_FEATURE:
            try {
                newState.featureToggles = [...newState.featureToggles];

                if (!newState.featureToggles.some((item) => item.id === action.id)) {
                    newState.featureToggles.push({
                        active: action.status,
                        description: action.description,
                        id: action.id,
                    });
                }

                newState.featureToggles.find((e) => e.id === action.id).active = action.status;
            } catch (error) {
                Logger.instance.error({
                    component: Components.FEATURE_TOGGLES,
                    error,
                    message: "Exception in feature toggle reducer TOGGLE_FEATURE",
                });
            }

            break;

        default:
            return state;
    }

    return newState;
}
